import { MEMBER_PLAN } from "./memberPlan";
import { hasBadge } from "../services/directChatRules";

/**
 * The plan chips (client, 23/10/2026):
 * - on their own account a Premium Lite member reads «P. LITE» (client,
 *   27/10/2026; the label is uppercased where it is drawn), everyone else
 *   what they read today;
 * - on someone else's profile the plan is shown only to the Team; a Team
 *   badge (Team DS, Nutrizionista DS…) is shown to everyone.
 */

/** The member's own plan name: «P. LITE» for Premium Lite, unless a badge (Team, ADOC) replaces it. */
export const ownPlanBadgeName = (name, memberPlan, { hasOwnBadge = false } = {}) =>
  !hasOwnBadge && memberPlan === MEMBER_PLAN.PREMIUM_LITE ? "P. LITE" : name;

/** Team = the viewer holds a badge (the same rule as writing to anyone). */
export const isTeamViewer = ({ subscriptionLabel = null, subscriberBadge = null } = {}) =>
  hasBadge(subscriptionLabel) || !!subscriberBadge;

/**
 * The chip on another member's profile: their Team badge for everyone, their
 * plan only for a Team viewer, otherwise nothing.
 */
export const otherProfileChip = (ownerLabel, viewerIsTeam) => {
  if (!ownerLabel || !ownerLabel.name) return null;
  if (hasBadge(ownerLabel)) return ownerLabel;
  return viewerIsTeam ? ownerLabel : null;
};
